import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "uz",
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === "number" && typeof value === "number") {
          return value.toLocaleString(lng === "uz" ? "uz-UZ" : "en-US");
        }
        return value;
      },
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: [
      "404",
      "dashboard",
      "email-verification",
      "employees",
      "forgot-password",
      "integrations",
      "layout",
      "login",
      "one-id",
      "reset-password",
      "settings",
      "sign-in",
      "sign-up",
      "social-support",
      "verify-phonenumber",
      "youth-details",
      "layout",
      "settings",
      "one-id",
      "login",
      "employees",
      "dashboard",
      "budget",
      "integrations",
      "opportunities-temp",
    ],
    supportedLngs: ["en", "uz"],
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
  });

export default i18n;
